var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Tooltip from "syf-component-library/ui/atoms/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import { FeaturedLabel, HelpTextContainer, DescriptionLabel, TooltipContainer, } from "./subcomponents";
var DescriptionTerm = function (_a) {
    var additionalLabel = _a.additionalLabel, label = _a.label, _b = _a.toolTipText, toolTipText = _b === void 0 ? null : _b, isLargerText = _a.isLargerText;
    return (_jsxs(DescriptionLabel, __assign({ as: "dt" }, { children: [isLargerText ? (_jsx(FeaturedLabel, __assign({ isInline: true, "data-cy": "label" }, { children: label }))) : (_jsx("span", __assign({ "data-cy": "label" }, { children: label }))), toolTipText && (_jsx(TooltipContainer, { children: _jsx(Tooltip, __assign({ placement: "bottom", isInteractive: false, ariaLabel: label, content: toolTipText }, { children: _jsx(FontAwesomeIcon, { icon: faQuestionCircle }) })) })), additionalLabel ? (_jsx(HelpTextContainer, __assign({ "data-cy": "additional-label" }, { children: additionalLabel }))) : undefined] })));
};
export default DescriptionTerm;
//# sourceMappingURL=DescriptionTerm.js.map